import React, { useEffect } from "react";
import NavItems from "src/components/layout/LayoutCompany/NavItems";
import Link from "src/components/Link";
import Logo from "src/components/Logo";
import useElementSize from "src/hooks/useElementSize";
import useLayout from "src/hooks/useLayout";

const LayoutSidebar = () => {
	const { size, ref } = useElementSize();
	const { layout, actions } = useLayout();

	useEffect(() => {
		actions.setNavbarSize({ size });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [size]);

	return (
		<>
			<div className="flex">
				<div style={{ width: size.width }} className="block"></div>
			</div>
			<div
				{...{ ref }}
				style={{ zIndex: 94 }}
				className="bg-dark flex flex-col fixed left-0 top-0 bottom-0"
			>
				<div
					className={`${
						layout.navbar.variant === "default"
							? "p-6"
							: "p-4 justify-center items-center"
					} min-h-[112px] flex flex-col`}
				>
					<Link to="/dashboard">
						<Logo
							className={`${
								layout.navbar.variant === "default"
									? "w-10 h-10"
									: "w-6 h-8"
							} block`}
							color="primary"
							variant="small"
						/>
					</Link>
				</div>
				<NavItems />
			</div>
		</>
	);
};

export default LayoutSidebar;
